import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
const SecondarySidebarFullWidthOnMobileLayout = ({ sidebar, children, contentFullScreen, contentMobileFullScreen, navbar, large, }) => {
    React.useLayoutEffect(() => {
        // @ts-expect-error - TS2339 - Property '_aviso_fit_to_parent_initialize' does not exist on type 'Window & typeof globalThis'.
        window._aviso_fit_to_parent_initialize();
    }, []);
    if (!sidebar) {
        return children;
    }
    return (_jsxs("div", { children: [_jsxs("aside", { className: classNames("secondary-sidebar-container fit-to-parent-parent", {
                    "secondary-sidebar-container-lg": large,
                }), children: [navbar || null, _jsx("div", { className: classNames("secondary-sidebar border-right border-right custom-scrollbar", {
                            "secondary-sidebar-under-nav": !!navbar,
                        }), children: sidebar })] }), _jsx("div", { className: classNames("secondary-sidebar-content", {
                    "full-screen": contentFullScreen,
                    "mobile-full-screen": contentMobileFullScreen,
                }), children: children })] }));
};
export default SecondarySidebarFullWidthOnMobileLayout;
